// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"761":"d372b426","832":"0ea0d6b0"}[chunkId] + ".chunk.css";
};